import { SamplingPoint } from '../../domain/sampling-point';
import { mapper } from '../../tools/mapping/mapper';
import { SamplingPointEntity } from '../entity';
import type { AppDB } from '../db';

export class SamplingPointRepository {
    constructor(private readonly database: AppDB) {}


    async getSamplingPointById(samplingPointId: number) {
        return await this.database.samplingPoints.where('Id').equals(samplingPointId).first(async spe => {
            const samplingPoint = mapper.map(spe, SamplingPointEntity, SamplingPoint);
            return samplingPoint;
        });
    }

    async attachSamplingPoint(sp: SamplingPoint, intId: number) {
        let samplingPointId: number;
        const spe = mapper.map(sp, SamplingPoint, SamplingPointEntity);

        samplingPointId = await this.database.samplingPoints.add(spe);
        await this.database.interventions.update(intId, {
            SamplingPointId: samplingPointId
        });
        return samplingPointId;

    }
}
